export default __webpack_public_path__ + "static/media/yi.676082c5.jpg";